/* eslint-disable */

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import {
  doc,
  getDoc,
} from "firebase/firestore";

import { db } from "../../firebase";

function toJsDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  if (typeof value.seconds === "number") return new Date(value.seconds * 1000);
  if (typeof value._seconds === "number") return new Date(value._seconds * 1000);

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatUKDateTime(value) {
  const date = toJsDate(value);
  if (!date) return "—";

  return date.toLocaleString("en-GB", {
    timeZone: "Europe/London",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function AgreementViewerPage() {
  const [params] = useSearchParams();

  const agreementId = params.get("agreementId");

  const [loading, setLoading] = useState(true);
  const [agreement, setAgreement] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadAgreement() {
      try {
        setLoading(true);

        if (!agreementId) {
          setError("No agreement ID provided.");
          return;
        }

        const agreementRef = doc(db, "agreements", agreementId);

        const snap = await getDoc(agreementRef);

        if (!snap.exists()) {
          setError("Agreement not found.");
          return;
        }

        setAgreement({
          id: snap.id,
          ...snap.data(),
        });
      } catch (err) {
        console.error(err);
        setError("Failed to load agreement.");
      } finally {
        setLoading(false);
      }
    }

    loadAgreement();
  }, [agreementId]);

  if (loading) {
    return (
      <CenteredCard>
        <div style={styles.loading}>Loading agreement...</div>
      </CenteredCard>
    );
  }

  if (error) {
    return (
      <CenteredCard>
        <div style={styles.error}>{error}</div>
      </CenteredCard>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.badge}>
          Immutable signed agreement
        </div>

        <h1 style={styles.title}>
          {agreement?.schoolName || "Agreement"}
        </h1>

        <p style={styles.text}>
          This agreement has been securely signed and stored.
        </p>

        <div style={styles.grid}>
          <Meta
            label="Agreement ID"
            value={agreement?.id}
          />

          <Meta
            label="Agreement Version"
            value={agreement?.agreementVersion || "v1"}
          />

         <Meta
  label="Signed By"
  value={
    agreement?.signerName ||
    agreement?.signedByName ||
    agreement?.recipientName ||
    "-"
  }
/>

<Meta
  label="Signer Role"
  value={
    agreement?.signerRole ||
    agreement?.signedByRole ||
    agreement?.role ||
    "School Administrator"
  }
/>

<Meta
  label="Signed Email"
  value={
    agreement?.signerEmail ||
    agreement?.signedByEmail ||
    agreement?.recipientEmail ||
    "-"
  }
/>

          <Meta
            label="Signed At"
            value={formatUKDateTime(agreement?.signedAt || agreement?.signedAtIso)}
          />
        </div>

        <div style={styles.hashBox}>
          <div style={styles.hashLabel}>
            SHA-256 Agreement Hash
          </div>

          <div style={styles.hashValue}>
            {agreement?.agreementHash || "-"}
          </div>
        </div>

        <div style={styles.footer}>
          {agreement?.pdfUrl ? (
            <a
              href={agreement.pdfUrl}
              target="_blank"
              rel="noreferrer"
              style={styles.primaryBtn}
            >
              Download Immutable PDF
            </a>
          ) : (
            <div style={styles.pending}>
              PDF not available yet.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Meta({ label, value }) {
  return (
    <div style={styles.metaCard}>
      <div style={styles.metaLabel}>{label}</div>
      <div style={styles.metaValue}>
        {String(value || "-")}
      </div>
    </div>
  );
}

function CenteredCard({ children }) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>{children}</div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "#f4f7fb",
    padding: 24,
  },

  card: {
    width: "100%",
    maxWidth: 920,
    borderRadius: 32,
    background: "#ffffff",
    border: "1px solid #dbe7ff",
    padding: 36,
    boxShadow: "0 24px 80px rgba(15,23,42,0.1)",
  },

  badge: {
    display: "inline-flex",
    padding: "9px 14px",
    borderRadius: 999,
    background: "#ecfdf3",
    color: "#166534",
    fontWeight: 950,
    marginBottom: 18,
  },

  title: {
    margin: 0,
    fontSize: 46,
    lineHeight: 1,
    fontWeight: 950,
    letterSpacing: "-0.05em",
    color: "#0f172a",
  },

  text: {
    marginTop: 18,
    color: "#475569",
    lineHeight: 1.7,
  },

  grid: {
    marginTop: 30,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
    gap: 16,
  },

  metaCard: {
    borderRadius: 22,
    background: "#f8fbff",
    border: "1px solid #dbeafe",
    padding: 18,
  },

  metaLabel: {
    fontSize: 12,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "#64748b",
    marginBottom: 10,
  },

  metaValue: {
    color: "#0f172a",
    fontWeight: 850,
    lineHeight: 1.6,
    wordBreak: "break-word",
  },

  hashBox: {
    marginTop: 28,
    borderRadius: 24,
    background: "#0f172a",
    padding: 24,
  },

  hashLabel: {
    color: "#93c5fd",
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: 12,
  },

  hashValue: {
    color: "#ffffff",
    fontFamily: "monospace",
    lineHeight: 1.8,
    wordBreak: "break-all",
    fontSize: 14,
  },

  footer: {
    marginTop: 30,
    display: "flex",
    justifyContent: "flex-end",
  },

  primaryBtn: {
    textDecoration: "none",
    border: "none",
    borderRadius: 18,
    padding: "16px 24px",
    background:
      "linear-gradient(135deg,#2563eb 0%,#7c3aed 100%)",
    color: "#ffffff",
    fontWeight: 900,
    boxShadow: "0 18px 40px rgba(79,70,229,0.25)",
  },

  pending: {
    color: "#b45309",
    fontWeight: 850,
  },

  loading: {
    fontSize: 18,
    fontWeight: 900,
    color: "#334155",
  },

  error: {
    color: "#b91c1c",
    fontWeight: 900,
    fontSize: 18,
  },
};